import { useStoreState } from '@discover-data/stores/restaurant/hooks';
import type { RestaurantToShow } from '@discover-data/stores/restaurant/model/types';
import useRegularOnly from '@discover-data/stores/hooks/regularOnly/useRegularOnly';
import AvailabilitySection from '@discover-components/availability/section';
import useRegularTableConfig from '@discover-components/availability/hooks/useRegularTableConfig';
import RegularAvailabilityCarousel from './carousel';
import RegularAvailabilityButton from './button';

export type RegularAvailabilitySectionProps = {
  restaurant: RestaurantToShow;
};

function RegularAvailabilitySection({ restaurant }: RegularAvailabilitySectionProps) {
  const { points } = useRegularTableConfig(restaurant);
  const discoverEnabled = useStoreState((state) => state.discoverEnabled);
  const [regularOnly] = useRegularOnly();
  const sectionProps = {
    points,
  };

  if (discoverEnabled && regularOnly) {
    return (
      <AvailabilitySection heading="Regular Table" {...sectionProps}>
        <RegularAvailabilityCarousel restaurant={restaurant} />
      </AvailabilitySection>
    );
  }

  return <RegularAvailabilityButton restaurant={restaurant} />;
}

export default RegularAvailabilitySection;
